export const HOME_SPOTLIGHT_PANEL_ID = 'home-spotlight-panel';
